import React, { createContext, FC, useContext } from 'react';
import type { CallIntegrationRequest } from '@glueapp/graph-types';

export const CallIntegrationContext = createContext<(request: CallIntegrationRequest) => void>(() => {});

interface CallIntegrationContextProviderProps {
    setCallIntegration: (request: CallIntegrationRequest) => void;
    children: React.ReactNode;
}

export const CallIntegrationContextProvider: FC<CallIntegrationContextProviderProps> = props => {
    return <CallIntegrationContext.Provider value={props.setCallIntegration}>{props.children}</CallIntegrationContext.Provider>;
};

export function useCallIntegration() {
    return useContext(CallIntegrationContext);
}
